/**
 *
 * DistanceFilters
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { FormGroup } from 'react-bootstrap';
import withUiControl from 'containers/UiControl/withUiControl';
import withSettings from 'containers/SettingsProvider/withSettings';

import messages from './messages';
import NumericInput from '../../NumericInput';

const Wrapper = styled(FormGroup)`
  display: flex;
  align-items: center;
  & > div {
    margin: 0 10px;
    flex: 1 0 1em;
  }
`;

class DistanceFilters extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key) {
    const { uiChange } = this.props;
    return value => {
      uiChange(key)(value);
    };
  }

  renderFilter(key, min, max) {
    const value = this.props[key];
    return (
      <NumericInput
        id={key}
        name={key}
        value={value}
        onChange={this.handleChange(key)}
        min={min}
        max={max}
      />
    );
  }

  render() {
    const { routesMin, routesMax, units } = this.props;
    return (
      <Wrapper>
        <FormattedMessage {...messages.from} />
        {this.renderFilter('routesMin', 0, routesMax)}
        <FormattedMessage {...messages.to} />
        {this.renderFilter('routesMax', routesMin)}
        {units}
      </Wrapper>
    );
  }
}

DistanceFilters.propTypes = {
  routesMin: PropTypes.number,
  routesMax: PropTypes.number,
  uiChange: PropTypes.func.isRequired,
  units: PropTypes.string.isRequired,
};

const uiControls = ['routesMin', 'routesMax'];
export default compose(
  withSettings(['units']),
  withUiControl(uiControls),
)(DistanceFilters);
